const HAS_PROTOCOL = /^[a-z][a-z0-9+.-]*:/i;
const LOOKS_LIKE_DOMAIN = /^[\w-]+(\.[\w-]+)+([\/?#].*)?$/i;

function normalizeHref(raw: string): string {
  const href = raw.trim().split(/\s+/)[0];
  if (!href || href === '#') {
    return href;
  }
  if (HAS_PROTOCOL.test(href) || href.startsWith('//')) {
    return href;
  }
  if (href.startsWith('/') || href.startsWith('#') || href.startsWith('?')) {
    return href;
  }
  if (LOOKS_LIKE_DOMAIN.test(href)) {
    return `https://${href}`;
  }
  return href;
}

export function normalizeQuillHtml(html: string): string {
  if (!html) {
    return '';
  }

  const cleaned = html
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/&shy;|&#173;|&#xad;/gi, '')
    .replace(/\u00AD/g, '')
    .replace(/[\u200B\u200C\u200D\u2060\uFEFF]/g, '');

  return cleaned.replace(/(<[^>]+>)|([^<]+)/g, (_match, tag: string | undefined, text: string | undefined) => {
    if (tag) {
      return tag;
    }
    return (text ?? '').replace(/([A-Za-z0-9\u0600-\u06FF])-([A-Za-z0-9\u0600-\u06FF])/g, '$1\u2011$2');
  });
}

export function prepareSeoContentLinks(html: string): string {
  const normalized = normalizeQuillHtml(html);
  if (!normalized.trim() || typeof document === 'undefined') {
    return normalized.trim();
  }

  const root = document.createElement('div');
  root.innerHTML = normalized.trim();

  root.querySelectorAll('a[href]').forEach((anchor) => {
    const href = normalizeHref(anchor.getAttribute('href') ?? '');
    anchor.setAttribute('href', href);

    if (HAS_PROTOCOL.test(href) || href.startsWith('//')) {
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    }
  });

  return root.innerHTML;
}
